import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconDownload48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="download">
            <path
                d="M25 0L25 42.1441L39.5859 27.5858L41.0001 29L25 44.9724V45H24.9724L23.9706 46L7 29L8.41421 27.5858L23 42.1991L23 0H25Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M23.9706 46L42 46V48H6V46L23.9706 46Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconDownload24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="download">
            <path
                d="M13.0211 0.000970448L13.0037 18.153L19.5832 11.5026L21 12.9142L12.0012 22L3.08579 12.9142L4.50001 11.5L11.0037 18.1515L11.0211 -0.00094223L13.0211 0.000970448Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M2 24L22 24.0001L22 22.0001L2.00001 22L2 24Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconDownload16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="download">
            <path
                d="M9.01403 0.000950704L9.00423 10.2505L13 6.58579L14.4142 8L8.00001 14L2.00001 8L3.41422 6.58579L7.0043 10.1759L7.01403 -0.000961304L9.01403 0.000950704Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M1 16L14.3333 16.0001L14.3333 14.0001L1.00001 14L1 16Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
